module.exports = __webpack_public_path__ + "img/end.902a1416.svg";